<template>
  <v-col cols="12" class="pt-0">
    <v-container
      :class="'popup-select-container elevation-5 '"
    >
      <v-row
        class="my-0 mt-0 mb-2 align-center"
        dense
        style="border-bottom: 1px solid #ddd; padding-bottom: 5px; margin-bottom: 5px;"
      >
        <v-col cols="1" text-center />
        <v-col
          :cols="sidebar ? 9 : 10"
          class="text-center"
        >
          <b>{{ $i18n.t('booking_extras') }}</b>
        </v-col>
        <v-col
          :cols="sidebar ? 2 : 1"
          class="text-right"
        >
          <v-btn
            small dark fab icon outlined
            class="form-close"
            color="green"
            @click="$emit('close')"
          >
            <v-icon small>fa-check</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="(bookingExtra, index) in bookingExtras"
        :key="index"
        class="align-center"
        dense
      >
        <template v-if="bookingExtraIsAllowed(bookingExtra)">
          <v-col cols="6">{{ bookingExtra['name_' + lang] }}</v-col>
          <v-col cols="2" class="text-right pr-3">{{ bookingExtra.price }} €</v-col>

          <v-col cols="4" class="text-center">
            <v-row class="align-center" no-gutters>
              <v-col cols="4" class="text-right">
                <v-btn
                  class="plus-minus-btn sidebar-plus elevation-0 mx-0"
                  color="#219bc8"
                  :small="!isMobileView"
                  dark
                  fab
                  @click="remove(index)"
                >
                  <v-icon small>fa-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="4" class="text-center">
                {{ (bookingExtrasSelected && bookingExtrasSelected[index]) || 0 }}
              </v-col>
              <v-col cols="4" class="text-left">
                <v-btn
                  class="plus-minus-btn sidebar-plus elevation-0 mx-0"
                  color="#219bc8"
                  dark
                  fab
                  @click="add(index)"
                >
                  <v-icon small>fa-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import sharedComputed from '../../methods/sharedComputed'
import sharedMethods from '../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'BookingFormExtras',

  components: {
  },

  data: () => {
    return {
      opened: false
    }
  },

  computed: {
    ...sharedComputed,
    ...mapFields(Object.keys(state)),

    computedMobile () {
      return this.mobile || this.sidebar || this.isMobileView
    }
  },

  props: {
    sidebar: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    ...sharedMethods,

    bookingExtraIsAllowed (extra) {
      if (!extra.requiredFeature) { return true }
      const featureId = extra.requiredFeature.id
      const featurePresent = featureId && this.object.features && this.object.features[featureId]
      const featureActive = featurePresent && this.object.features[featureId].checked
      return featureActive
    },

    add (index) {
      this.$store.dispatch('addBookingExtra', index)
    },

    remove (index) {
      this.$store.dispatch('removeBookingExtra', index)
    },
  }
}
</script>

<style>
.plus-minus-btn {
  height: 24px !important;
  width: 24px !important;
  /* color: #219bc8 !important; */
}
.form-check {
  height: 24px !important;
  width: 24px !important;
  color: #fac400 !important;
}
.form-close {
  height: 24px !important;
  width: 24px !important;
}
@media only screen and (max-width: 320px) {
  .booking-exras-container {
    font-size: 11px;
    padding: 8px !important;
  }
  .booking-exras-container .form-close {
    /* left: -10px; */
  }
}
</style>
